module.exports = __webpack_public_path__ + "static/img/baner1.2a35cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/baner1.png
// module id = KXqx
// module chunks = 0